import { refreshAuthToken } from "api/auth";
import { redirectUnauthenticated } from "../helpers/helpers";

let refreshInFlight = null;

const refreshToken = () => {
  if (window.localStorage.is_refresh && refreshInFlight) {
    return refreshInFlight;
  }
  const token = window.localStorage.getItem("refresh_token");
  if (!token) {
    redirectUnauthenticated();
    return Promise.reject(new Error("no_refresh_token"));
  }
  if (refreshInFlight) {
    return refreshInFlight;
  }

  window.localStorage.setItem("is_refresh", "true");
  refreshInFlight = refreshAuthToken(token)
    .then((resp) => {
      if (!resp?.data?.access) {
        throw new Error("refresh_failed");
      }
      window.localStorage.setItem("refresh_token", resp.data.refresh);
      window.localStorage.setItem("access_token", resp.data.access);
      window.localStorage.removeItem("is_refresh");
    })
    .catch(() => {
      window.localStorage.removeItem("is_refresh");
      window.localStorage.removeItem("refresh_token");
      window.localStorage.removeItem("access_token");
      redirectUnauthenticated();
    })
    .finally(() => {
      refreshInFlight = null;
    });

  return refreshInFlight;
};

export { refreshToken };
